/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Test_FailInputs */

const cs_sreality_test_fail = /** @type {(inputs: Sreality_Test_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení na Sreality selhalo`)
};

const en_sreality_test_fail = /** @type {(inputs: Sreality_Test_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality login failed`)
};

/**
* | output |
* | --- |
* | "Sreality login failed" |
*
* @param {Sreality_Test_FailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_test_fail = /** @type {((inputs?: Sreality_Test_FailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Test_FailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_test_fail(inputs)
	return cs_sreality_test_fail(inputs)
});